import React from "react";

// Official Dynamis logo assets (served from /public).
export const Logo = ({ className = "", variant = "header" }) => {
  if (variant === "full") {
    return (
      <img
        src="/logo.png"
        alt="Dynamis Decision Intelligence — From Potential to Action"
        className={`h-auto w-[220px] max-w-full ${className}`}
        width="220"
      />
    );
  }
  return (
    <img
      src="/logo-header.png"
      alt="Dynamis Decision Intelligence"
      className={`h-8 w-auto ${className}`}
      height="32"
    />
  );
};
